import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { checkValidity, getURLSegment, closeDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import Textarea from 'react-textarea-autosize';
import DatePicker from 'react-datepicker';
import moment from 'moment';

// Components
import TimeSelect2 from '../Modules/TimeSelect2';

const AddFundingRule = observer(class AddFundingRule extends React.Component {
  constructor() {
    super();
    this.handleStartChange = this.handleStartChange.bind(this);
    this.handleEndChange = this.handleEndChange.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.complete = this.complete.bind(this);
  }

  componentWillMount() {
    const { SessionStore } = this.props.store;

    this.state = {
      startDate: null,
      endDate: null,
      fundingRuleData: {
        amount: 0,
        title: null,
        description: '',
        units: '$',
        currency: null,
        appliesTo: null,
        effectiveDate: null,
        expirationDate: null,
        courseSid: '',
        enrollmentSid: '',
        examSid: '',
        userSid: '',
        courseOfferingSid: ''
      }
    }

    SessionStore.getCurrencies();

    if(this.props.fundingRuleSid) {
      // If a funding rule sid is provided, get that rule
      this.getFundingRule();
    } else {
      // Otherwise make sure there’s no rule data in the store
      this.resetFundingRule();
    }

    if(
      this.props.courseSid ||
      this.props.enrollmentSid ||
      this.props.examSid ||
      this.props.userSid ||
      this.props.offeringSid
    ) {
      let fundingRuleData = {...this.state.fundingRuleData};

      if(this.props.courseSid) {
        fundingRuleData.courseSid = this.props.courseSid;
      }
      if(this.props.enrollmentSid) {
        fundingRuleData.enrollmentSid = this.props.enrollmentSid;
      }
      if(this.props.examSid) {
        fundingRuleData.examSid = this.props.examSid;
      }
      if(this.props.userSid) {
        fundingRuleData.userSid = this.props.userSid;
      }
      if(this.props.offeringSid) {
        fundingRuleData.courseOfferingSid = this.props.offeringSid;
      }

      this.setState({
        fundingRuleData
      })
    }
  }

  getFundingRule() {
    this.props.store.FundingRuleStore.getFundingRule(this.props.fundingRuleSid, this);
  }

  resetFundingRule() {
    this.props.store.FundingRuleStore.resetFundingRule(this.props.fundingRuleSid);
  }

  handleStartChange(date, isDateField) {
    if(isDateField) {
      this.setState({
        startDate: date
      });
    } else {
      date = this.state.startDate;
    }

    const time = this.startTime.value;

    // Update form data
    this.updateDates(date, time, 'effectiveDate');
  }

  handleEndChange(date, isDateField) {
    if(isDateField) {
      this.setState({
        endDate: date
      });
    } else {
      date = this.state.endDate;
    }

    const time = this.endTime.value;

    // Update form data
    this.updateDates(date, time, 'expirationDate');
  }

  updateDates(date, time, whichDate) {
    const { userTimezone } = this.props.store.SessionStore;
    let fundingRuleData = {...this.state.fundingRuleData};

    const dateString = moment(date).format('YYYY-MM-DD');
    const timezoneString = moment(date).tz(userTimezone).format('Z');
    fundingRuleData[whichDate] = moment.utc(`${dateString} ${time} ${timezoneString}`, 'YYYY-MM-DD HH:mm Z').tz(userTimezone).toISOString();

    this.setState({
      fundingRuleData
    });
  }

  handleInput(e, checkbox, ref) {
    let fundingRuleData = {...this.state.fundingRuleData};

    fundingRuleData.amount = this.amount.value || '';
    fundingRuleData.title = this.title.value || '';
    fundingRuleData.description = this.description.value || '';
    fundingRuleData.units = this.units.value || '';

    fundingRuleData.appliesTo = this.appliesTo.value || '';

    if(this.currency) {
      fundingRuleData.currency = this.currency.value || null;
    }

    this.setState({
      fundingRuleData
    })
  }

  handleSubmit(e) {
    const { FundingRuleStore } = this.props.store;
    const _this = this;

    if(this.props.fundingRuleSid) {
      // Updating an existing rule
      // If updating, make sure the dates are right since they may not have changed them
      this.updateDates(this.state.startDate, this.startTime.value, 'effectiveDate');

      setTimeout(function(){
        _this.updateDates(_this.state.endDate, _this.endTime.value, 'expirationDate');

        FundingRuleStore.updateFundingRule(_this.props.fundingRuleSid, _this.state.fundingRuleData, _this.complete);
      })
    } else {
      // Creating a new rule
      // If there’s a scope in the URL, grab the SID and add it to the data
      const { fundingRuleScope, scopeSid } = this.props.routing.location.query;

      if(fundingRuleScope && scopeSid) {
        let fundingRuleData = {...this.state.fundingRuleData};

        fundingRuleData[fundingRuleScope] = scopeSid;

        this.setState({
          fundingRuleData
        })
      }

      // Create the rule
      setTimeout(function(){
        FundingRuleStore.createFundingRule(_this.state.fundingRuleData, _this.complete);
      });
    }
  }

  complete() {
    if(!this.props.preserveDrawer) {
      closeDrawer(null, this.props.parent, getURLSegment(this, 1));
    } else {
      this.props.parent.setState({
        drawerContent: 'FundingRules',
        fundingRuleSid: null
      })
    }

    this.props.store.SessionStore.showToaster(this.props.translation.rule_saved, 'success');
  }

  render() {
    const { enrollmentSid, translation } = this.props;
    const { FundingRuleStore, SessionStore } = this.props.store;
    const { fundingRuleData } = FundingRuleStore;
    const { userTimezone } = this.props.store.SessionStore;

    const _this = this;

    if((this.props.fundingRuleSid && this.state.startDate && SessionStore.currencyList.length > 0) || !this.props.fundingRuleSid) {
      return(
        <div className="drawer__content">
          <header className="drawer__header">
            <div className="wrap">
              <h1 className="drawer__title">{translation.heading}</h1>
            </div>
          </header>

          <div className="wrap">
            <form className="panel panel--medium" onSubmit={(e) => checkValidity(e, this.handleSubmit)} noValidate>
              {enrollmentSid &&
                <input
                  type="hidden"
                  ref={(input) => {this.enrollmentSid = input}}
                  defaultValue={enrollmentSid}
                />
              }

              <fieldset>
                <ul className="fields">
                  <li>
                    <label className="lbl-required" htmlFor="funding-name">{translation.name.label}</label>
                    <input type="text" id="funding-name" required aria-required="true" ref={(input) => {this.title = input}} onChange={this.handleInput} defaultValue={fundingRuleData.title} />
                  </li>
                  <li>
                    <label className="lbl-optional" htmlFor="funding-details">{translation.details.label}</label>
                    <Textarea id="funding-details" className="textarea-grow" ref={(input) => {this.description = input}} onChange={this.handleInput} defaultValue={fundingRuleData.description}></Textarea>
                  </li>
                  <li className="field--auto">
                    <label className="lbl-required" htmlFor="funding-amount">{translation.amount.label}</label>

                    <input
                      type="number"
                      id="funding-amount"
                      defaultValue={fundingRuleData.amount}
                      ref={(input) => {this.amount = input}}
                      onChange={this.handleInput}
                      placeholder="0"
                      min="0"
                      max={this.state.fundingRuleData.units === '%' ? '100' : '1000000'}
                      required
                      aria-required="true"
                    />

                    <label className="select" htmlFor="funding-unit">
                      <span className="meta">{translation.amount.units}</span>
                      <select
                        id="funding-unit"
                        ref={(input) => {this.units = input}}
                        onChange={this.handleInput}
                        defaultValue={this.state.fundingRuleData.units}
                      >
                        <option value="$">{translation.amount.money}</option>
                        <option value="%">{translation.amount.percentage}</option>
                      </select>
                    </label>

                    {this.state.fundingRuleData.units === '$' &&
                      <label className="select" htmlFor="funding-unit">
                        <span className="meta">{translation.currency.label}</span>
                        <select
                          id="funding-currency"
                          ref={(input) => {this.currency = input}}
                          onChange={this.handleInput}
                          required
                          aria-required="true"
                          defaultValue={this.state.fundingRuleData.currency}
                        >
                          <option value="">{translation.currency.label}</option>
                          {SessionStore.currencyList.map(
                            (key, i) =>
                            <option key={i} value={key.code}>{key.name}</option>
                          )}
                        </select>
                      </label>
                    }
                  </li>
                  <li className="field--auto">
                    <label className="lbl-required" htmlFor="funding-appliesTo">{translation.applies_to.label}</label>

                    <label className="select" htmlFor="funding-appliesTo">
                      <select
                        ref={(input) => {this.appliesTo = input}}
                        onChange={this.handleInput}
                        defaultValue={this.state.fundingRuleData.appliesTo}
                        required
                        aria-required="true"
                      >
                        <option value="">{translation.applies_to.helper}</option>
                        <option value="online">{translation.applies_to.virtual}</option>
                        <option value="in-person">{translation.applies_to.in_person}</option>
                      </select>
                    </label>
                  </li>
                  <li className="field--auto">
                    <label className="lbl-required" htmlFor="funding-start-date">
                      {translation.starts.label}
                    </label>

                    <DatePicker
                      id="funding-start-date"
                      selected={this.state.startDate ? moment(this.state.startDate).tz(userTimezone) : null}
                      onChange={(date) => {this.handleStartChange(date, true)}}
                      placeholderText={translation.starts.helper}
                      required aria-required="true"
                      ref={(input) => {this.effectiveDate = input}}
                      defaultValue={fundingRuleData.effectiveDate}
                      autoComplete="off"
                    />

                    <span className="preposition">{translation.starts.at}</span>

                    <label className="select" htmlFor="funding-start-time">
                      <select
                        id="funding-start-time"
                        ref={(input) => {this.startTime = input}}
                        onChange={() => this.handleStartChange(null, false)}
                        defaultValue={moment.utc(this.state.startDate).tz(userTimezone).format('HH:mm')}
                      >
                        <TimeSelect2 />
                      </select>
                    </label>

                    <span className="preposition">
                      {/* If a date is selected, use that date’s dst */}
                      {this.state.endDate &&
                        moment.utc(this.state.startDate).tz(userTimezone).format('z')
                      }

                      {/* Otherwise use the current date’s dst */}
                      {!this.state.endDate &&
                        moment().tz(userTimezone).format('z')
                      }
                    </span>
                  </li>
                  <li className="field--auto">
                    <label className="lbl-required" htmlFor="funding-end-date">
                      {translation.ends.label}
                    </label>

                    <DatePicker
                      id="funding-end-date"
                      selected={this.state.endDate ? moment(this.state.endDate).tz(userTimezone) : null}
                      onChange={(date) => {this.handleEndChange(date, true)}}
                      placeholderText={translation.ends.helper}
                      required
                      aria-required="true"
                      ref={(input) => {this.expirationDate = input}}
                      autoComplete="off"
                    />

                    <span className="preposition">{translation.ends.at}</span>

                    <label className="select" htmlFor="funding-end-time">
                      <select
                        id="funding-end-time"
                        ref={(input) => {this.endTime = input}}
                        onChange={() => this.handleEndChange(null, false)}
                        defaultValue={moment.utc(this.state.endDate).tz(userTimezone).format('HH:mm')}
                      >
                        <TimeSelect2 />
                      </select>
                    </label>

                    <span className="preposition">
                      {/* If a date is selected, use that date’s dst */}
                      {this.state.endDate &&
                        moment.utc(this.state.endDate).tz(userTimezone).format('z')
                      }

                      {/* Otherwise use the current date’s dst */}
                      {!this.state.endDate &&
                        moment().tz(userTimezone).format('z')
                      }
                    </span>
                  </li>
                </ul>
              </fieldset>

              <div className="panel__actions actions">
                <button className="actions__btn actions__btn--primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      )
    }

    return null;
  }
})

export default translate('AddFundingRule')(AddFundingRule);



// WEBPACK FOOTER //
// ./src/app/components/FundingRules/AddFundingRule.js